import moment from 'moment';

const fiveHundredMs = 500;

// 引入OSS
const OSS = require('ali-oss');
// OSS实例化
export const oss = new OSS({
  region: "oss-cn-hangzhou",
  secure: true,
  accessKeyId: "LTAI5tMkZiUtMnCq9iYEfHyp",
  accessKeySecret: "xdNbSqS3xUABOrP7DboizLFxjw7QTE",
  bucket: "shiyanjia-reports",
  endpoint: "oss-accelerate.aliyuncs.com",
  timeout: 180000
});

export const isAuthenticated = () => {
  return getCookie('vendorid');
}

export const isIE = () => {
  if (document.documentMode && document.documentMode < 11) {
    alert("您的浏览器版本过低，暂不支持，请使用现代浏览器、IE11、Microsoft Edge");
  }
}

// 设置cookie
export const setCookie = (name, value, days) => {
  let exp = new Date();
  exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

// 读取cookie
export const getCookie = (name) => {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return decodeURIComponent(arr[2]);
  } else {
    return '';
  }
};

export const isProprietarySupplier = (proprietary = getCookie('proprietary')) => String(proprietary) === '1';

export const canAccessPerformance = (proprietary = getCookie('proprietary')) => isProprietarySupplier(proprietary);

// 删除cookie
export const delCookie = (name) => {
  let exp = new Date();
  let cval = getCookie(name);
  exp.setTime(exp.getTime() - 1);
  if (cval) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
}

export const timeDiff = (start, end) => {
  let duration = '';
  if (end === 0 || end === '') {
    return '--';
  }
  const startTime = moment(start).valueOf();
  const endTime = moment(end).valueOf();
  const usedTime = endTime - startTime;
  const days = Math.floor(usedTime / (24 * 3600 * 1000));
  const leavel = usedTime % (24 * 3600 * 1000);
  const hours = Math.floor(leavel / (3600 * 1000));
  const leavel2 = leavel % (3600 * 1000);
  const minutes = Math.floor(leavel2 / (60 * 1000));
  if (days > 0) {
    duration = duration + days + '天';
  };
  if (hours > 0) {
    duration = duration + hours + '小时';
  };
  if (minutes > 0) {
    duration = duration + minutes + '分钟';
  };
  return duration;
};

/**
 * 为功能函数封装防抖功能
 * @param func {function} - 功能函数
 * @param [delay] {number} - 防抖间隔时间
 * @returns {function(...[*]): Promise<unknown>} - 防抖功能函数
 */
export const debounce = (func, delay = fiveHundredMs) => {
  let timer = null;
  return (...params) => {
    return new Promise((resolve, reject) => {
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        resolve(func(...params));
      }, delay);
    });
  }
}

export const filterOptionFn = (input, option) => {
  if (typeof option?.label === 'string') {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  if (Array.isArray(option?.label)) {
    return option.label.join('').toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  if (typeof option?.children === 'string') {
    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  if (Array.isArray(option?.children)) {
    return option.children.join('').toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  return false;
};
